<template>
  <div class="stepper-step">
    <!-- Desktop -->
    <div
      class="d-flex align-items-center justify-content-center stepper-step"
      :class="{
        'stepper-step--active': active,
        'stepper-step--passed': passed
      }"
    >
      <template v-if="passed">
        <span
          class="stepper-step__icon stepper-step__icon--error"
          v-if="step.hasErrors"
        >
          <icon icon="error" />
        </span>
        <span
          class="stepper-step__icon stepper-step__icon--valid"
          v-else-if="step.isValid"
        >
          <icon
            class="valid-step"
            icon="success"
          />
        </span>
        <span
          class="stepper-step__icon stepper-step__icon--invalid"
          v-else
        >
          <icon
            class="invalid-step"
            icon="iso-grid"
          />
        </span>
      </template>
      <span
        v-else
        class="stepper-step__icon"
      >
        {{ index + 1 }}
      </span>
      <span class="stepper-step__title">{{ step.title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step',

  props: {
    step: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      required: true,
    },

    active: {
      type: Boolean,
      default: () => false,
    },

    passed: {
      type: Boolean,
      default: () => false,
    },
  },
}
</script>
